import { render, staticRenderFns } from "./Form_area.vue?vue&type=template&id=36fa8d83&scoped=true&"
import script from "./Form_area.vue?vue&type=script&lang=js&"
export * from "./Form_area.vue?vue&type=script&lang=js&"
import style0 from "./Form_area.vue?vue&type=style&index=0&id=36fa8d83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa8d83",
  null
  
)

export default component.exports